var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-title',{staticClass:"big-title",attrs:{"title":_vm.title}}),_c('b-card-body',[_vm._t("default")],2),_c('span',{domProps:{"innerHTML":_vm._s(_vm.footer)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }